import axios from "axios";
import { PaginateModel } from "../../../models/PaginateModel";
import { PaymentRequestModel, SearchModel } from "../../../models/PaymentRequestModel";
import { IResponseModel } from "../../../models/DashboardModel";
import { IAxiosSuccess } from "../../../models/AxiosModel";
import { ADMIN_PAYMENT_REQUEST_ENDPOINT, ADMIN_STORES_ENDPOINT } from "../../../constants/endpoints";



export interface PaymentRequestListModel {
  paginate_data: PaginateModel<PaymentRequestModel>,
  sub_total: number
}

export function getList(params?: SearchModel) {
  return axios.get<PaymentRequestListModel>(`${ADMIN_PAYMENT_REQUEST_ENDPOINT}`, {params})
}

export function getStoreDebt(id: number) {
  return axios.get<IResponseModel>(`${ADMIN_STORES_ENDPOINT}/debt/${id}`)
}

export function createRequest(params: PaymentRequestModel) {
  return axios.post<IAxiosSuccess>(ADMIN_PAYMENT_REQUEST_ENDPOINT, params)
}

export function updateRequest(params: PaymentRequestModel) {
  return axios.post<IAxiosSuccess>(`${ADMIN_PAYMENT_REQUEST_ENDPOINT}/${params.id}`, params)
}

export function updateRequestStatus(id: number, status: string) {
  return axios.post<IAxiosSuccess>(`${ADMIN_PAYMENT_REQUEST_ENDPOINT}/update-status`, {id, status})
}

export function addPaymentDoc(formData: FormData) {
  return axios.post<IAxiosSuccess>(`${ADMIN_PAYMENT_REQUEST_ENDPOINT}/add-doc`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function removePaymentDoc(params: {id: number, request_id: number}) {
  return axios.post<IAxiosSuccess>(`${ADMIN_PAYMENT_REQUEST_ENDPOINT}/remove-doc`, params)
}